import { localStorage } from 'dibs-browser-storage';
import { actionTypes } from './constants';
import get from 'lodash.get';

const CART_ID = 'cart';

function getLocalStorageItems() {
    return localStorage.getItem(CART_ID) || [];
}

/**
 * MW-541 - Bug caused local storage item IDs to be wrapped in an array.
 * This causes an error so fix any bad local storage items
 */
function fixLocalStorageItems(items) {
    return items.map(item => {
        if (Array.isArray(item.id)) {
            item.id = item.id[0];
        }

        return item;
    });
}

/**
 * The desktop stores each cart item as an object, with an id key containing the item id.
 */
function buildLocalStorageItems(current, next) {
    return current
        .map(({ id }) => id)
        .filter(id => !next.includes(id))
        .concat(next)
        .map(id => ({ id }));
}

export function loadLocalCart() {
    const currentCart = fixLocalStorageItems(getLocalStorageItems());
    // will be ignored if componentShouldUpdate is on
    // if we remove that, then the type needs to change to be handled by reducer appropriately
    return { type: actionTypes.SET_CART_ITEMS, payload: { items: currentCart } };
}

export function consolidateCart(payload) {
    const items = get(payload, 'res.addCartItem.portfolioItems');
    const cart = get(payload, 'cartItems');
    // once the request to save new cart items is successful,
    // theres no need to keep the local cart anymore
    localStorage.deleteItem(CART_ID);
    return { type: actionTypes.SET_CART_ITEMS, payload: { items: cart.concat(items) } };
}

export function setCartItems(itemId) {
    const currentCart = getLocalStorageItems();
    const cartItems = buildLocalStorageItems(currentCart, itemId);
    localStorage.setItem(CART_ID, cartItems);
    return { type: actionTypes.SET_CART_ITEMS, payload: { items: cartItems } };
}
